import _typeof from "@babel/runtime/helpers/typeof";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * NDJSON helpers for the detail drawer's log viewers. Worker-portable.
 *
 * Strategy (deliberate): logs are read as ONE whole entry (the zip layer
 * can't range into DEFLATE data), size-guarded via the central directory
 * BEFORE any byte is fetched. Splitting is a single native pass; the
 * expensive part — per-line JSON.parse — happens lazily, only for rows the
 * virtualizer actually renders.
 */

function asRecord(v) {
  return v !== null && _typeof(v) === 'object' && !Array.isArray(v) ? v : null;
}

/** Split NDJSON text into raw lines: CRLF-tolerant, blanks dropped. */
export function splitNdjsonLines(text) {
  var lines = text.split('\n');
  var out = [];
  var _iterator = _createForOfIteratorHelper(lines),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var line = _step.value;
      var trimmed = line.endsWith('\r') ? line.slice(0, -1) : line;
      if (trimmed.trim() !== '') out.push(trimmed);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return out;
}

/**
 * Parse one console NDJSON line. Marker/rollup lines (no `text`) return
 * null — they're structural, not log rows. A line that isn't valid JSON
 * renders verbatim as a `raw` row: never silently dropped.
 */
export function parseConsoleLine(line, index) {
  var doc = null;
  try {
    doc = asRecord(JSON.parse(line));
  } catch (_unused) {
    return {
      seq: index,
      level: 'log',
      text: line,
      url: null,
      raw: true
    };
  }
  if (!doc) {
    return {
      seq: index,
      level: 'log',
      text: line,
      url: null,
      raw: true
    };
  }
  if (typeof doc.text !== 'string') return null;
  return {
    seq: typeof doc.sequence === 'number' ? doc.sequence : index,
    level: typeof doc.level === 'string' && doc.level !== '' ? doc.level : 'log',
    text: doc.text,
    url: typeof doc.url === 'string' && doc.url !== '' ? doc.url : null,
    raw: false
  };
}